import { Route, createBrowserRouter, createRoutesFromElements, Outlet, RouterProvider } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import {
  ADMIN,
  HOME,
  LOGIN,
  REPORT_DETAIL,
  USER_DETAIL,
  VERSION,
  INACTIVE_USER,
  REPORT_DETAIL_AND_ACTION,
} from './config/routes';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import DashboardPage from './pages/DashboardPage';
import NotFoundPage from './pages/NotFoundPage';
import Layout from './components/Layout';
import './assets/styles/normalize.css';
import './assets/styles/styles.css';
import './components/StoraEnsoComponents/assets/css/styles.css';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import VersionPage from './pages/VersionPage';
import AdminPage from './pages/AdminPage';
import ReportDetailPage from './pages/ReportDetailPage';
import UserDetailPage from './pages/UserDetailPage';
import InactiveUserPage from './pages/InactiveUserPage';

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route
        path={HOME}
        element={
          <div>
            <Outlet />
          </div>
        }
      >
        <Route path="*" element={<NotFoundPage />} />
        <Route path={LOGIN} element={<LoginPage />} />
        <Route path={VERSION} element={<VersionPage />} />
        <Route path={INACTIVE_USER} element={<InactiveUserPage />} />
        <Route
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route index path={HOME} element={<DashboardPage />} />
          <Route path={REPORT_DETAIL} element={<ReportDetailPage />} />
          <Route path={REPORT_DETAIL_AND_ACTION} element={<ReportDetailPage />} />
          <Route path={USER_DETAIL} element={<UserDetailPage />} />
          <Route
            path={ADMIN}
            element={
              <AdminRoute>
                <AdminPage />
              </AdminRoute>
            }
          />
        </Route>
      </Route>,
    ),
  );

  return <RouterProvider router={router} />;
}

export default App;
